// import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Component, OnInit } from '@angular/core';

import { TournamentsService } from './../tournaments/services/tournaments.service';
declare let $;
declare let SetLanguage: any;
@Component({
    selector: 'comp_bettingslip_balance_info_modal',
    templateUrl: './bettingslip_balance_info_modal.html',
})
export class BettingSlipBalanceInfoModal implements OnInit {
    public init: boolean;
    constructor(public tournamentsService: TournamentsService) {}
    public ngOnInit() {
        if (this.init) {
            return;
        }
        this.init = true;
    }
    public Balance_Info_Modal_Button_Ok() {
        $('#BettingSlip_Balance_Info_Modal').modal('hide');
        $('#BettingSlip_Balance_Modal').modal('hide');
    }
}
